/* all action type name constants go in this one file
 convention: ${feature}/${functionality}${ajaxState}
 ${ajaxState} can be nothing, or one of the following:
 - _REQUESTED
 - _RECEIVED
 - _FAILED
 convention important here since things like loading spinner will rely on this
*/

// NEW CONSTANTS
export const DELETE_RATE_REQUESTED = "DELETE/DELETE_RATE_REQUESTED";
export const DELETE_RATE_RECEIVED = "DELETE/DELETE_RATE_RECEIVED";
export const DELETE_RATE_FAILED = "DELETE/DELETE_RATE_FAILED";

export const CONFIGURE_RATE_REQUESTED = "RATE/CONFIGURE_RATE_REQUESTED";
export const CONFIGURE_RATE_RECEIVED = "RATE/CONFIGURE_RATE_RECEIVED";
export const CONFIGURE_RATE_FAILED = "RATE/CONFIGURE_RATE_FAILED";

export const EDIT_RATE_REQUESTED = "RATE/EDIT_RATE_REQUESTED";
export const EDIT_RATE_RECEIVED = "RATE/EDIT_RATE_RECEIVED";
export const EDIT_RATE_FAILED = "RATE/EDIT_RATE_FAILED";

export const FETCH_RATES_REQUESTED = "RATE/FETCH_RATES_REQUESTED";
export const FETCH_RATES_RECEIVED = "RATE/FETCH_RATES_RECEIVED";
export const FETCH_RATES_FAILED = "RATE/FETCH_RATES_FAILED";
export const UNSET_RATE_ERROR = "RATE/UNSET_ERROR";

export const CONFIGURE_TAX_REQUESTED = "TAX/CONFIGURE_TAX_REQUESTED";
export const CONFIGURE_TAX_RECEIVED = "TAX/CONFIGURE_TAX_RECEIVED";
export const CONFIGURE_TAX_FAILED = "TAX/CONFIGURE_TAX_FAILED";

export const DELETE_TAX_REQUESTED = "TAX/DELETE_TAX_REQUESTED";
export const DELETE_TAX_RECEIVED = "TAX/DELETE_TAX_RECEIVED";
export const DELETE_TAX_FAILED = "TAX/DELETE_TAX_FAILED";

export const FETCH_TAXES_REQUESTED = "TAX/FETCH_TAXES_REQUESTED";
export const FETCH_TAXES_RECEIVED = "TAX/FETCH_TAXES_RECEIVED";
export const FETCH_TAXES_FAILED = "TAX/FETCH_TAXES_FAILED";
export const UNSET_TAX_ERROR = "TAX/UNSET_ERROR";

export const CREATE_LOCATION_REQUESTED = "LOCATION/CREATE_LOCATION_REQUESTED";
export const CREATE_LOCATION_RECEIVED = "LOCATION/CREATE_LOCATION_RECEIVED";
export const CREATE_LOCATION_FAILED = "LOCATION/CREATE_LOCATION_FAILED";

export const UPDATE_LOCATION_REQUESTED = "LOCATION/UPDATE_LOCATION_REQUESTED";
export const UPDATE_LOCATION_RECEIVED = "LOCATION/UPDATE_LOCATION_RECEIVED";
export const UPDATE_LOCATION_FAILED = "LOCATION/UPDATE_LOCATION_FAILED";

export const FETCH_ALL_BILLING_ACCOUNTS_REQUESTED =
  "ACCOUNTS/FETCH_ALL_BILLING_ACCOUNTS_REQUESTED";
export const FETCH_ALL_BILLING_ACCOUNTS_RECEIVED =
  "ACCOUNTS/FETCH_ALL_BILLING_ACCOUNTS_RECEIVED";
export const FETCH_ALL_BILLING_ACCOUNTS_FAILED =
  "ACCOUNTS/FETCH_ALL_BILLING_ACCOUNTS_FAILED";

export const CREATE_CONTACT_REQUESTED = "ACCOUNTS/CREATE_CONTACT_REQUESTED";
export const CREATE_CONTACT_RECEIVED = "ACCOUNTS/CREATE_CONTACT_RECEIVED";
export const CREATE_CONTACT_FAILED = "ACCOUNTS/CREATE_CONTACT_FAILED";

export const UPDATE_CONTACT_REQUESTED = "ACCOUNTS/UPDATE_CONTACT_REQUESTED";
export const UPDATE_CONTACT_RECEIVED = "ACCOUNTS/UPDATE_CONTACT_RECEIVED";
export const UPDATE_CONTACT_FAILED = "ACCOUNTS/UPDATE_CONTACT_FAILED";

export const FETCH_CONTACT_REQUESTED = "ACCOUNTS/FETCH_CONTACT_REQUESTED";
export const FETCH_CONTACT_RECEIVED = "ACCOUNTS/FETCH_CONTACT_RECEIVED";
export const FETCH_CONTACT_FAILED = "ACCOUNTS/FETCH_CONTACT_FAILED";

export const FETCH_CONTACTS_REQUESTED = "ACCOUNTS/FETCH_CONTACTS_REQUESTED";
export const FETCH_CONTACTS_RECEIVED = "ACCOUNTS/FETCH_CONTACTS_RECEIVED";
export const FETCH_CONTACTS_FAILED = "ACCOUNTS/FETCH_CONTACTS_FAILED";

export const CREATE_BILLING_ACCOUNT_REQUESTED =
  "ACCOUNTS/CREATE_BILLING_ACCOUNT_REQUESTED";
export const CREATE_BILLING_ACCOUNT_RECEIVED =
  "ACCOUNTS/CREATE_BILLING_ACCOUNT_RECEIVED";
export const CREATE_BILLING_ACCOUNT_FAILED =
  "ACCOUNTS/CREATE_BILLING_ACCOUNT_FAILED";

export const DELETE_BILLING_ACCOUNT_REQUESTED =
  "ACCOUNTS/DELETE_BILLING_ACCOUNT_REQUESTED";
export const DELETE_BILLING_ACCOUNT_RECEIVED =
  "ACCOUNTS/DELETE_BILLING_ACCOUNT_RECEIVED";
export const DELETE_BILLING_ACCOUNT_FAILED =
  "ACCOUNTS/DELETE_BILLING_ACCOUNT_FAILED";

export const FETCH_BTU_METER_READINGS_REQUESTED =
  "USAGE/FETCH_BTU_METER_READINGS_REQUESTED";
export const FETCH_BTU_METER_READINGS_RECEIVED =
  "USAGE/FETCH_BTU_METER_READINGS_RECEIVED";
export const FETCH_BTU_METER_READINGS_FAILED =
  "USAGE/FETCH_BTU_METER_READINGS_FAILED";

export const FETCH_BILLING_ACCOUNT_REQUESTED =
  "ACCOUNT/FETCH_BILLING_ACCOUNT_REQUESTED";
export const FETCH_BILLING_ACCOUNT_RECEIVED =
  "ACCOUNT/FETCH_BILLING_ACCOUNT_RECEIVED";
export const FETCH_BILLING_ACCOUNT_FAILED =
  "ACCOUNT/FETCH_BILLING_ACCOUNT_FAILED";

export const SET_SELECTED_LOCATION = "LOCATION/SET_SELECTED_LOCATION";
export const FETCH_LOCATION_RECEIVED = "LOCATION/FETCH_LOCATION_RECEIVED";
export const FETCH_ALL_LOCATIONS_COMPLETED =
  "LOCATION/FETCH_ALL_LOCATIONS_COMPLETED";
export const FETCH_LOCATION_REQUESTED = "LOCATION/FETCH_LOCATION_REQUESTED";
export const FETCH_LOCATION_FAILED = "LOCATION/FETCH_LOCATION_FAILED";

export const CREATE_INVOICES_REQUESTED = "INVOICE/CREATE_INVOICES_REQUESTED";
export const CREATE_INVOICES_RECEIVED = "INVOICE/CREATE_INVOICES_RECEIVED";
export const CREATE_INVOICES_FAILED = "INVOICE/CREATE_INVOICES_FAILED";

export const FETCH_ALL_INVOICES_REQUESTED =
  "INVOICE/FETCH_ALL_INVOICES_REQUESTED";
export const FETCH_ALL_INVOICES_RECEIVED =
  "INVOICE/FETCH_ALL_INVOICES_RECEIVED";
export const FETCH_ALL_INVOICES_FAILED = "INVOICE/FETCH_ALL_INVOICES_FAILED";

export const SET_SELECTED_INVOICE = "INVOICE/SET_SELECTED_INVOICE";
export const UNSET_SELECTED_INVOICE = "INVOICE/UNSET_SELECTED_INVOICE";

export const SEND_INVOICES_REQUESTED = "INVOICE/SEND_INVOICES_REQUESTED";
export const SEND_INVOICES_RECEIVED = "INVOICE/SEND_INVOICES_RECEIVED";
export const SEND_INVOICES_FAILED = "INVOICE/SEND_INVOICES_FAILED";

export const ADD_INVOICE_ITEM_REQUESTED = "INVOICE/ADD_INVOICE_ITEM_REQUESTED";
export const ADD_INVOICE_ITEM_RECEIVED = "INVOICE/ADD_INVOICE_ITEM_RECEIVED";
export const ADD_INVOICE_ITEM_FAILED = "INVOICE/ADD_INVOICE_ITEM_FAILED";

export const EDIT_INVOICE_ITEM_REQUESTED =
  "INVOICE/EDIT_INVOICE_ITEM_REQUESTED";
export const EDIT_INVOICE_ITEM_RECEIVED = "INVOICE/EDIT_INVOICE_ITEM_RECEIVED";
export const EDIT_INVOICE_ITEM_FAILED = "INVOICE/EDIT_INVOICE_ITEM_FAILED";

export const REMOVE_INVOICE_ITEM_REQUESTED =
  "INVOICE/REMOVE_INVOICE_ITEM_REQUESTED";
export const REMOVE_INVOICE_ITEM_RECEIVED =
  "INVOICE/REMOVE_INVOICE_ITEM_RECEIVED";
export const REMOVE_INVOICE_ITEM_FAILED = "INVOICE/REMOVE_INVOICE_ITEM_FAILED";

export const FETCH_INVOICE_REQUESTED = "INVOICE/FETCH_INVOICE_REQUESTED";
export const FETCH_INVOICE_RECEIVED = "INVOICE/FETCH_INVOICE_RECEIVED";
export const FETCH_INVOICE_FAILED = "INVOICE/FETCH_INVOICE_FAILED";

export const EMAIL_INVOICES_REQUESTED = "INVOICE/EMAIL_INVOICES_REQUESTED";
export const EMAIL_INVOICES_RECEIVED = "INVOICE/EMAIL_INVOICES_RECEIVED";
export const EMAIL_INVOICES_FAILED = "INVOICE/EMAIL_INVOICES_FAILED";

export const FETCH_BTU_METERS_REQUESTED = "METER/FETCH_BTU_METERS_REQUESTED";
export const FETCH_BTU_METERS_RECEIVED = "METER/FETCH_BTU_METERS_RECEIVED";
export const FETCH_BTU_METERS_FAILED = "METER/FETCH_BTU_METERS_FAILED";

export const FETCH_METERS_REQUESTED = "METER/FETCH_METERS_REQUESTED";
export const FETCH_METERS_RECEIVED = "METER/FETCH_METERS_RECEIVED";
export const FETCH_METERS_FAILED = "METER/FETCH_METERS_FAILED";

export const FETCH_METER_READINGS_REQUESTED =
  "USAGE/FETCH_METER_READINGS_REQUESTED";
export const FETCH_METER_READINGS_RECEIVED =
  "USAGE/FETCH_METER_READINGS_RECEIVED";
export const FETCH_METER_READINGS_FAILED = "USAGE/FETCH_METER_READINGS_FAILED";

export const FETCH_ACCOUNT_FILTERED_METERS_REQUESTED =
  "ACCOUNT/FETCH_ACCOUNT_FILTERED_METERS_REQUESTED";
export const FETCH_ACCOUNT_FILTERED_METERS_RECEIVED =
  "ACCOUNT/FETCH_ACCOUNT_FILTERED_METERS_RECEIVED";
export const FETCH_ACCOUNT_FILTERED_METERS_FAILED =
  "ACCOUNT/FETCH_ACCOUNT_FILTERED_METERS_FAILED";

export const DELETE_INVOICES_REQUESTED = "INVOICE/DELETE_INVOICES_REQUESTED";
export const DELETE_INVOICES_RECEIVED = "INVOICE/DELETE_INVOICES_RECEIVED";
export const DELETE_INVOICES_FAILED = "INVOICE/DELETE_INVOICES_FAILED";

export const SET_ACCOUNT_INFO = "ACCOUNT/ACCOUNT_INFO_SET";
export const UNSET_ACCOUNT_INFO = "ACCOUNT/ACCOUNT_INFO_UNSET";

export const ADD_LOCATION_FILTER = "ACCOUNT/ADD_LOCATION_FILTER";
export const ADD_GROUP_FILTER = "ACCOUNT/ADD_GROUP_FILTER";

export const SET_CREDITABLE_METERS = "ACCOUNT/SET_CREDIT_METERS";
export const SET_BILLABLE_METERS = "ACCOUNT/SET_BILLABLE_METERS";
export const SET_PARTIAL_METERS = "ACCOUNT/SET_PARTIAL_METERS";

export const ADD_BILLABLE_LOCATION_FILTER =
  "ACCOUNT/ADD_BILLABLE_LOCATION_FILTER";
export const ADD_BILLABLE_GROUP_FILTER = "ACCOUNT/ADD_BILLABLE_GROUP_FILTER";
export const ADD_BILLABLE_METER_FILTER = "ACCOUNT/ADD_BILLABLE_METER_FILTER";

export const ADD_CREDITABLE_LOCATION_FILTER =
  "ACCOUNT/ADD_CREDITABLE_LOCATION_FILTER";
export const ADD_CREDITABLE_GROUP_FILTER =
  "ACCOUNT/ADD_CREDITABLE_GROUP_FILTER";
export const ADD_CREDITABLE_METER_FILTER =
  "ACCOUNT/ADD_CREDITABLE_METER_FILTER";

export const ADD_PARTIAL_LOCATION_FILTER =
  "ACCOUNT/ADD_PARTIAL_LOCATION_FILTER";
export const ADD_PARTIAL_GROUP_FILTER = "ACCOUNT/ADD_PARTIAL_GROUP_FILTER";
export const ADD_PARTIAL_METER_FILTER = "ACCOUNT/ADD_PARTIAL_METER_FILTER";
export const SET_PARTIAL_METER_PERCENTAGE =
  "ACCOUNT/SET_PARTIAL_METER_PERCENTAGE";

export const RESET_PARTIAL_METERS = "ACCOUNT/RESET_PARTIAL_METERS";
export const RESET_BILLABLE_METERS = "ACCOUNT/RESET_BILLABLE_METERS";
export const RESET_CREDITABLE_METERS = "ACCOUNT/RESET_CREDITABLE_METERS";

export const FETCH_ELECTRICAL_METERS_REQUESTED =
  "METER/FETCH_ELECTRICAL_METERS_REQUESTED";
export const FETCH_ELECTRICAL_METERS_RECEIVED =
  "METER/FETCH_ELECTRICAL_METERS_RECEIVED";
export const FETCH_ELECTRICAL_METERS_FAILED =
  "METER/FETCH_ELECTRICAL_METERS_FAILED";

export const FETCH_BILLING_ACCOUNT_CONTACT_REQUESTED =
  "ACCOUNT/FETCH_BILLING_ACCOUNT_CONTACT_REQUESTED";
export const FETCH_BILLING_ACCOUNT_CONTACT_RECEIVED =
  "ACCOUNT/FETCH_BILLING_ACCOUNT_CONTACT_RECEIVED";
export const FETCH_BILLING_ACCOUNT_CONTACT_FAILED =
  "ACCOUNT/FETCH_BILLING_ACCOUNT_CONTACT_FAILED";

export const PRINT_INVOICE_REQUESTED = "INVOICE/PRINT_INVOICE_REQUESTED";
export const PRINT_INVOICE_RECEIVED = "INVOICE/PRINT_INVOICE_RECEIVED";
export const PRINT_INVOICE_FAILED = "INVOICE/PRINT_INVOICE_FAILED";

export const UNSET_INVOICE_ERROR = "INVOICE/UNSET_INVOICE_ERROR";

export const USER_LOGIN_REQUESTED = "SECURITY/USER_LOGIN_REQUESTED";
export const USER_LOGIN_RECEIVED = "SECURITY/USER_LOGIN_RECEIVED";
export const USER_LOGIN_FAILED = "SECURITY/USER_LOGIN_FAILED";

export const USER_LOGOUT_REQUESTED = "SECURITY/USER_LOGOUT_REQUESTED";
export const USER_LOGOUT_RECEIVED = "SECURITY/USER_LOGOUT_RECEIVED";
export const USER_LOGOUT_FAILED = "SECURITY/USER_LOGOUT_FAILED";

export const ADD_METER_TO_BILLING_ACCOUNT_REQUESTED =
  "ACCOUNTS/ADD_METER_TO_BILLING_ACCOUNT_REQUESTED";
export const ADD_METER_TO_BILLING_ACCOUNT_RECEIVED =
  "ACCOUNTS/ADD_METER_TO_BILLING_ACCOUNT_RECEIVED";
export const ADD_METER_TO_BILLING_ACCOUNT_FAILED =
  "ACCOUNTS/ADD_METER_TO_BILLING_ACCOUNT_FAILED";

export const REMOVE_METER_FROM_BILLING_ACCOUNT_REQUESTED =
  "ACCOUNTS/REMOVE_METER_FROM_BILLING_ACCOUNT_REQUESTED";
export const REMOVE_METER_FROM_BILLING_ACCOUNT_RECEIVED =
  "ACCOUNTS/REMOVE_METER_FROM_BILLING_ACCOUNT_RECEIVED";
export const REMOVE_METER_FROM_BILLING_ACCOUNT_FAILED =
  "ACCOUNTS/REMOVE_METER_FROM_BILLING_ACCOUNT_FAILED";

export const CONFIGURE_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_REQUESTED =
  "ACCOUNTS/CONFIGURE_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_REQUESTED";
export const CONFIGURE_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_RECEIVED =
  "ACCOUNTS/CONFIGURE_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_RECEIVED";
export const CONFIGURE_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_FAILED =
  "ACCOUNTS/CONFIGURE_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_FAILED";

export const UNSET_ACCOUNT_ERROR = "ACCOUNT/UNSET_INVOICE_ERROR";

export const EDIT_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_REQUESTED =
  "ACCOUNTS/EDIT_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_REQUESTED";
export const EDIT_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_RECEIVED =
  "ACCOUNTS/EDIT_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_RECEIVED";
export const EDIT_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_FAILED =
  "ACCOUNTS/EDIT_BILLING_ACCOUNT_PARTIAL_METER_PERCENTAGE_FAILED";

export const PRINT_REPORT_REQUESTED = "REPORTS/PRINT_REPORT_REQUESTED";
export const PRINT_REPORT_RECEIVED = "REPORTS/PRINT_REPORT_RECEIVED";
export const PRINT_REPORT_FAILED = "REPORTS/PRINT_REPORT_FAILED";

export const CLEAR_INVOICING_RESULTS = "INVOICE/CLEAR_INVOICING_RESULTS";

export const POST_INVOICE_REQUESTED = "INVOICE/POST_INVOICE_REQUESTED";
export const POST_INVOICE_RECEIVED = "INVOICE/POST_INVOICE_RECEIVED";
export const POST_INVOICE_FAILED = "INVOICE/POST_INVOICE_FAILED";

export const ARCHIVE_INVOICES_REQUESTED = "INVOICE/ARCHIVE_INVOICES_REQUESTED";
export const ARCHIVE_INVOICES_RECEIVED = "INVOICE/ARCHIVE_INVOICES_RECEIVED";
export const ARCHIVE_INVOICES_FAILED = "INVOICE/ARCHIVE_INVOICES_FAILED";

export const FETCH_DRAFT_INVOICES_REQUESTED =
  "INVOICE/FETCH_DRAFT_INVOICES_REQUESTED";
export const FETCH_DRAFT_INVOICES_RECEIVED =
  "INVOICE/FETCH_DRAFT_INVOICES_RECEIVED";
export const FETCH_DRAFT_INVOICES_FAILED =
  "INVOICE/FETCH_DRAFT_INVOICES_FAILED";

export const FETCH_INVOICES_REQUESTED = "INVOICE/FETCH_INVOICES_REQUESTED";
export const FETCH_INVOICES_RECEIVED = "INVOICE/FETCH_INVOICES_RECEIVED";
export const FETCH_INVOICES_FAILED = "INVOICE/FETCH_INVOICES_FAILED";

export const FETCH_ARCHIVED_INVOICES_REQUESTED =
  "INVOICE/FETCH_ARCHIVED_INVOICES_REQUESTED";
export const FETCH_ARCHIVED_INVOICES_RECEIVED =
  "INVOICE/FETCH_ARCHIVED_INVOICES_RECEIVED";
export const FETCH_ARCHIVED_INVOICES_FAILED =
  "INVOICE/FETCH_ARCHIVED_INVOICES_FAILED";

export const UPLOAD_FILE_REQUESTED = "UPLOAD/UPLOAD_FILE_REQUESTED";
export const UPLOAD_FILE_RECEIVED = "UPLOAD/UPLOAD_FILE_RECEIVED";
export const UPLOAD_FILE_FAILED = "UPLOAD/UPLOAD_FILE_FAILED";

// ------- OLD CONSTANTS -----------------------
export const TOGGLE_D1 = "PLAY/TOGGLE_D1";
export const INCREMENT_D2 = "PLAY/INCREMENT_D2";
export const DECREMENT_D2 = "PLAY/DECREMENT_D2";

export const SET_BTU_METER_MODEL_REQUESTED = "BTUMETER/SET_MODEL_REQUESTED";
export const SET_BTU_METER_MODEL_RECEIVED = "BTUMETER/SET_MODEL_RECEIVED";
export const SET_BTU_METER_MODEL_FAILED = "BTUMETER/SET_MODEL_FAILED";

export const BULK_EDIT_METERS_REQUESTED = "METER/BULK_EDIT_REQUESTED";
export const BULK_EDIT_METERS_RECEIVED = "METER/BULK_EDIT_RECEIVED";
export const BULK_EDIT_METERS_FAILED = "METER/BULK_EDIT_FAILED";

export const FETCH_COP_VALUES_REQUESTED = "COP/FETCH_VALUES_REQUESTED";
export const FETCH_COP_VALUES_RECEIVED = "COP/FETCH_VALUES_RECEIVED";
export const FETCH_COP_VALUES_FAILED = "COP/FETCH_VALUES_FAILED";

export const SET_COP_VALUES_REQUESTED = "COP/SET_VALUES_REQUESTED";
export const SET_COP_VALUES_RECEIVED = "COP/SET_VALUES_RECEIVED";
export const SET_COP_VALUES_FAILED = "COP/SET_VALUES_FAILED";

export const BULK_SET_COP_VALUES_REQUESTED = "COP/BULK_SET_VALUES_REQUESTED";
export const BULK_SET_COP_VALUES_RECEIVED = "COP/BULK_SET_VALUES_RECEIVED";
export const BULK_SET_COP_VALUES_FAILED = "COP/BULK_SET_VALUES_FAILED";

export const EDIT_BTU_METER_REQUESTED = "BTUMETER/EDIT_REQUESTED";
export const EDIT_BTU_METER_RECEIVED = "BTUMETER/EDIT_RECEIVED";
export const EDIT_BTU_METER_FAILED = "BTUMETER/EDIT_FAILED";

export const EDIT_ELECTRICAL_METER_REQUESTED = "ELECTRICALMETER/EDIT_REQUESTED";
export const EDIT_ELECTRICAL_METER_RECEIVED = "ELECTRICALMETER/EDIT_RECEIVED";
export const EDIT_ELECTRICAL_METER_FAILED = "ELECTRICALMETER/EDIT_FAILED";

export const ACCOUNT_SET_GRID_SORT = "ACCOUNT/SET_GRID_SORT";
export const ACCOUNT_SET_GRID_FILTERS = "ACCOUNT/SET_GRID_FILTERS";

export const READING_REQUESTED = "READING/FETCH_VALUES_REQUESTED";
export const READING_RECEIVED = "READING/FETCH_VALUES_RECEIVED";
export const READING_FAILED = "READING/FETCH_VALUES_FAILED";

export const SET_READING_LOCATION = "READING/SET_READING_LOCATION";

export const APPROVE_METER_REQUESTED = "READING/APPROVE_METER_REQUESTED";
export const APPROVE_METER_RECEIVED = "READING/APPROVE_METER_RECEIVED";
export const APPROVE_METER_FAILED = "READING/APPROVE_METER_FAILED";




// WEBPACK FOOTER //
// ./src/actionTypes.js